module.exports = __webpack_public_path__ + "img/coupon-with-discount.8a4864ef.png";